import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import { BugReportsTypes, BugReportInterface } from './types';

// List BugReports
export const listBugReportsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(BugReportsTypes.LIST_BUG_REPORTS_REQUEST, payload);
export const listBugReportsSuccess = (payload: {
  bugReportsList: BugReportInterface[];
  totalCount: number;
}) => action(BugReportsTypes.LIST_BUG_REPORTS_SUCCESS, payload);
export const listBugReportsFailure = () =>
  action(BugReportsTypes.LIST_BUG_REPORTS_FAILURE);

// Get BugReport
export const getBugReportRequest = (payload: object) =>
  action(BugReportsTypes.GET_BUG_REPORT_REQUEST, payload);
export const getBugReportSuccess = (payload: {
  bugReportData: BugReportInterface;
}) => action(BugReportsTypes.GET_BUG_REPORT_SUCCESS, payload);
export const getBugReportFailure = () =>
  action(BugReportsTypes.GET_BUG_REPORT_FAILURE);

// Filter BugReports
export const filterBugReportsRequest = (payload: object) =>
  action(BugReportsTypes.FILTER_BUG_REPORTS_REQUEST, payload);
export const filterBugReportsSuccess = (payload: {
  bugReportsList: BugReportInterface[];
  totalCount: number;
}) => action(BugReportsTypes.FILTER_BUG_REPORTS_SUCCESS, payload);
export const filterBugReportsFailure = () =>
  action(BugReportsTypes.FILTER_BUG_REPORTS_FAILURE);

// Create BugReport
export const createBugReportRequest = (payload: object) =>
  action(BugReportsTypes.CREATE_BUG_REPORT_REQUEST, payload);
export const createBugReportSuccess = (payload: {
  bugReportData: BugReportInterface;
}) => action(BugReportsTypes.CREATE_BUG_REPORT_SUCCESS, payload);
export const createBugReportFailure = () =>
  action(BugReportsTypes.CREATE_BUG_REPORT_FAILURE);

// Update BugReport
export const updateBugReportRequest = (payload: object) =>
  action(BugReportsTypes.UPDATE_BUG_REPORT_REQUEST, payload);
export const updateBugReportSuccess = (payload: {
  bugReportData: BugReportInterface;
}) => action(BugReportsTypes.UPDATE_BUG_REPORT_SUCCESS, payload);
export const updateBugReportFailure = () =>
  action(BugReportsTypes.UPDATE_BUG_REPORT_FAILURE);

// Delete BugReport
export const deleteBugReportRequest = (payload: object) =>
  action(BugReportsTypes.DELETE_BUG_REPORT_REQUEST, payload);
export const deleteBugReportSuccess = () =>
  action(BugReportsTypes.DELETE_BUG_REPORT_SUCCESS);
export const deleteBugReportFailure = () =>
  action(BugReportsTypes.DELETE_BUG_REPORT_FAILURE);
